/**
 * 产品系列层级工具（官网用精简版）
 */

function sortSeries(a, b) {
  return (
    (a.sort_order ?? 0) - (b.sort_order ?? 0) ||
    (a.series_name_cn || '').localeCompare(b.series_name_cn || '', 'zh-CN')
  );
}

export function getChildSeries(seriesId, allSeries) {
  if (seriesId == null || seriesId === -1) return [];
  const pid = Number(seriesId);
  return allSeries
    .filter((s) => s.parent_id != null && Number(s.parent_id) === pid)
    .sort(sortSeries);
}

export function getRootSeries(allSeries) {
  return allSeries
    .filter((s) => s.parent_id == null || s.parent_id === '' || Number(s.parent_id) === 0)
    .sort(sortSeries);
}

export function getDescendantIds(seriesId, allSeries) {
  const ids = [];
  const walk = (pid) => {
    getChildSeries(pid, allSeries).forEach((child) => {
      ids.push(Number(child.id));
      walk(child.id);
    });
  };
  walk(seriesId);
  return ids;
}

export function getSelfAndDescendantIds(seriesId, allSeries) {
  return [Number(seriesId), ...getDescendantIds(seriesId, allSeries)];
}

export function findSeriesById(id, allSeries) {
  if (id == null) return null;
  return allSeries.find((s) => Number(s.id) === Number(id)) || null;
}

/** 根 → 当前，用 · 连接 */
export function getSeriesPathParts(series, allSeries, field = 'series_name_cn') {
  if (!series || series.id == null) return [];
  const byId = new Map(allSeries.map((s) => [Number(s.id), s]));
  const parts = [];
  let current = series;
  const guard = new Set();
  while (current) {
    const id = Number(current.id);
    if (!id || guard.has(id)) break;
    guard.add(id);
    const val = String(current[field] || '').trim();
    if (val) parts.unshift(val);
    const parentId = current.parent_id;
    if (parentId == null || parentId === '') break;
    current = byId.get(Number(parentId)) || null;
  }
  return parts;
}

export function getSeriesPathCn(series, allSeries) {
  return getSeriesPathParts(series, allSeries, 'series_name_cn').join('·');
}

export function getSeriesPathEn(series, allSeries) {
  return getSeriesPathParts(series, allSeries, 'series_name_en').join(' · ');
}

/** 该系列（含子孙）下是否有产品 */
export function seriesHasProducts(seriesId, allSeries, products) {
  const ids = new Set(getSelfAndDescendantIds(seriesId, allSeries));
  return products.some((p) => p.series_id != null && ids.has(Number(p.series_id)));
}
